var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-player"},[_c('video',{class:{ 'radius': _vm.radius == true },attrs:{"id":"video","src":_vm.videoPath,"controls":"","poster":_vm.poster}})])
}
var staticRenderFns = []

export { render, staticRenderFns }